/**
 * @generated SignedSource<<4516c8e06fdf01fe92a44796a9302630>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeploymentsQuery$variables = {
  possibleArtifactDeploymentsLocator: string;
  possibleSnapshotDeploymentsLocator: string;
};
export type DeploymentsQuery$data = {
  readonly possibleArtifactDeployments: {
    readonly count: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeploymentsFragment">;
  } | null;
  readonly possibleSnapshotDeployments: {
    readonly count: number | null;
    readonly " $fragmentSpreads": FragmentRefs<"DeploymentsFragment">;
  } | null;
};
export type DeploymentsQuery = {
  response: DeploymentsQuery$data;
  variables: DeploymentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "possibleArtifactDeploymentsLocator"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "possibleSnapshotDeploymentsLocator"
},
v2 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "possibleSnapshotDeploymentsLocator"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v4 = [
  (v3/*: any*/),
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "DeploymentsFragment"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "locator",
    "variableName": "possibleArtifactDeploymentsLocator"
  }
],
v6 = [
  (v3/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "BuildTypeRest",
    "kind": "LinkedField",
    "name": "buildType",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rawId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DeploymentsQuery",
    "selections": [
      {
        "alias": "possibleSnapshotDeployments",
        "args": (v2/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "buildTypes",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      },
      {
        "alias": "possibleArtifactDeployments",
        "args": (v5/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "buildTypes",
        "plural": false,
        "selections": (v4/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DeploymentsQuery",
    "selections": [
      {
        "alias": "possibleSnapshotDeployments",
        "args": (v2/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "buildTypes",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      },
      {
        "alias": "possibleArtifactDeployments",
        "args": (v5/*: any*/),
        "concreteType": "BuildTypes",
        "kind": "LinkedField",
        "name": "buildTypes",
        "plural": false,
        "selections": (v6/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "858da72483f78b22cc186acbda552aad",
    "id": null,
    "metadata": {},
    "name": "DeploymentsQuery",
    "operationKind": "query",
    "text": "query DeploymentsQuery(\n  $possibleSnapshotDeploymentsLocator: String!\n  $possibleArtifactDeploymentsLocator: String!\n) {\n  possibleSnapshotDeployments: buildTypes(locator: $possibleSnapshotDeploymentsLocator) {\n    count\n    ...DeploymentsFragment\n  }\n  possibleArtifactDeployments: buildTypes(locator: $possibleArtifactDeploymentsLocator) {\n    count\n    ...DeploymentsFragment\n  }\n}\n\nfragment DeploymentsFragment on BuildTypes {\n  buildType {\n    rawId\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe2931ff4ce25d50bdad531c39975b8c";

export default node;
